import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import blogPosts from 'data/blogPosts';
import NavbarStandard from '../landing/NavbarStandard';
import FooterStandard from '../landing/FooterStandard';
import 'assets/css/landing-overhaul.css';

const Blog = () => {
  return (
    <div className="wn-landing">
      <Helmet>
        <title>
          Blog | Widest Net Technologies — AI Insights for Distribution
        </title>
        <meta
          name="description"
          content="Practical guides and insights on AI, automation, and ecommerce for legacy distributors, CPG companies, and family-owned businesses — from an operator who's done it."
        />
        <meta
          name="keywords"
          content="AI for distributors, distribution automation, CPG ecommerce, family business AI, accounts payable automation, marketplace activation"
        />
        <link rel="canonical" href="https://widestnet.web.app/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://widestnet.web.app/blog" />
        <meta property="og:title" content="Blog | Widest Net Technologies" />
        <meta
          property="og:description"
          content="AI insights and practical guides for modern distributors."
        />
      </Helmet>

      <NavbarStandard />
      <section className="wn-section" style={{ paddingTop: 120 }}>
        <Container>
          <div className="wn-fade-in">
            <div className="wn-section-label">
              <span className="label-dot" />
              Insights
            </div>
            <h1 className="wn-section-title">
              AI insights for{' '}
              <span className="wn-gradient-text">modern distributors</span>
            </h1>
            <p className="wn-section-subtitle">
              Practical guides on AI, automation, and ecommerce for legacy
              distributors, CPG companies, and family-owned businesses — from an
              operator who's done it.
            </p>
          </div>

          <div className="wn-blog-grid">
            {blogPosts.map((post, i) => (
              <Link
                to={`/blog/${post.slug}`}
                key={post.slug}
                className={`wn-blog-card wn-fade-in wn-fade-in-delay-${i + 1}`}
              >
                <span className="wn-blog-tag">{post.tag}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <div className="wn-blog-meta">
                  <span>{post.author}</span>
                  <span>·</span>
                  <span>{post.readTime}</span>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
      <FooterStandard />
    </div>
  );
};

export default Blog;
